export const delayedScrollIntoView = (targetElement: HTMLElement) => {
  let timeout = 0;
  const header = window.document.getElementsByTagName('header')[0];
  const offset = header.getBoundingClientRect().height + 71;
  const sizeObserver = new ResizeObserver(() => {
    clearTimeout(timeout);
    _scrollTo(targetElement, offset);
    timeout = setTimeout(() => {
      _scrollTo(targetElement, offset);
      sizeObserver.disconnect();
    }, 500);
  });

  sizeObserver.observe(window.document.body);
};

function _scrollTo(targetElement: HTMLElement, yOffset: number) {
  const y =
    (targetElement?.getBoundingClientRect().top || 0) +
    window.scrollY -
    yOffset;

  window.scrollTo({ top: y, behavior: 'smooth' });
}
